import { Space } from "@mantine/core";
import React, { Fragment } from "react";

import { DESCRIPTION, EQUIPEMENT, THERE_IS_NO_DATA_FOUND } from "Constant";

import Translate from "Components/Translate";

import { isEmpty } from "./isEmpty";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const EquipmentsComp = ({ data, taxiData }) => {
  if (isEmpty(data)) return isEmpty(data);

  const {
    box,
    luminous,
    printer,
    sunshield,
    sos_button,
    stylus,
    relay_switch,
    sensor,
    obd_adapter,
    bracket,
  } = data;

  const noFiltererequiredKeys = [
    { title: "Boîtier", serial: box?.box },
    { title: "Lumineux", serial: luminous?.luminous },
    { title: "Imprimante thermique", serial: printer?.printer },
    { title: "Visière", serial: sunshield?.sunshield },
    { title: "Bouton SOS", serial: sos_button?.sos_button },
    { title: "Stylet", serial: stylus?.stylus },
    { title: "Relais Stop voiture", serial: relay_switch?.relay_switch },
    { title: "Capteur", serial: sensor?.sensor },
    { title: "Adaptateur obd", serial: obd_adapter?.obd_adapter },
    { title: "Support", serial: bracket?.bracket },
  ];
  const requiredKeys = noFiltererequiredKeys.filter((item) =>
    Boolean(item.serial)
  );

  const taximeterCode = taxiData?.taximeter?.code_taximeter ?? null;

  return (
    <Fragment>
      <Space h="md" />

      <DataTable
        size="small"
        value={requiredKeys}
        responsiveLayout="scroll"
        emptyMessage={<Translate>{THERE_IS_NO_DATA_FOUND}</Translate>} // Empty state message
      >
        <Column field="title" header={<Translate>{EQUIPEMENT}</Translate>} />
        <Column field="serial" header={<Translate>{DESCRIPTION}</Translate>} />
      </DataTable>
      {/* <DataTable value={requiredKeys} size="small">
        <Column field="title" header="Equipment" />
        <Column
          field="serial"
          header="Serial"
          body={({ serial }) => {
            if (!serial) return <IconXboxX color="red" />;
          }}
        />
      </DataTable> */}
    </Fragment>
  );
};

export default EquipmentsComp;
